var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogCirclesDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 350,
    viewBox: "0 0 288 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 214,
    r: 136,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 214,
    r: 119,
    fill: "#FFFFF6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 214,
    r: 102,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 214,
    r: 85,
    fill: "#FFFFF6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 214,
    r: 68,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 214,
    r: 51,
    fill: "#FFFFF6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 93,
    r: 93,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 93,
    r: 81.375,
    fill: "#FFFFF6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 93,
    r: 69.75,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 93,
    r: 58.125,
    fill: "#FFFFF6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 93,
    r: 46.5,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 93,
    r: 34.875,
    fill: "#FFFFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogCirclesDown);
export default __webpack_public_path__ + "static/media/blogCirclesDown.95f654b55ea29dd2bed6e4e1b0a45734.svg";
export { ForwardRef as ReactComponent };